// extracted by css-extract-rspack-plugin
export default {"step":"step-G1YuaD","legend":"legend-pTMTQF"};